import { render, staticRenderFns } from "./EvdHistorical.vue?vue&type=template&id=1296e6b6&scoped=true&"
import script from "./EvdHistorical.vue?vue&type=script&lang=js&"
export * from "./EvdHistorical.vue?vue&type=script&lang=js&"
import style0 from "./EvdHistorical.vue?vue&type=style&index=0&id=1296e6b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296e6b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VContainer,VDataTable,VIcon,VRow})
